import React from "react";
import "../../Styles/Form/MoveSectionmodal.css";
import closeIcon from "../../Assets/propertiesCloseIcon.svg";
import { useSelector } from "react-redux";
import up_arrow from "../../Assets/up_arrow.svg";
import down_arrow from "../../Assets/down_arrow.svg";
import sectionDNDIcon from "../../Assets/sectionDNDIcon.svg";

const MoveSectionModel = ({ isOpen, onClose }) => {
  const form = useSelector((state) => state.form.form);
  if (!isOpen) return null;

  return (
    <div className="selectTagmodal-overlay">
      <div className="selectTagmodal-content">
        <div className="sectionmodel_closeicon">
          <p>Move section</p>
          <img src={closeIcon} alt="close-btn" style={{ cursor: "pointer" }} onClick={onClose}/>
        </div>
        <p>Move section to created section moving forward and backward</p>
        {form.sections.map((section, sindex) => (
          <div className="section_modal_single">
            <div>
              <img src={sectionDNDIcon} alt="sectionDNDIcon" />
            </div>
            <div className="text_section_name">
              <div className="section_tile_cunt">
                <p className="section_title_sectionModal">
                  Lorem Ipsum has been the
                </p>
                <p className="section_count">
                  Section {sindex + 1} 0f {form.sections.length}
                </p>
              </div>
              <div className="arrow_container">
                <div>
                  <img src={up_arrow} alt="arrow" />
                </div>
                <div>
                  <img src={down_arrow} alt="arrow" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MoveSectionModel;
